import { Component, OnInit, Inject } from '@angular/core';
import { ModalService } from '../modal.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-assignlead',
    templateUrl: './assignlead.component.html',
    styleUrls: ['./assignlead.component.scss'],
    standalone: false
})
export class AssignleadComponent implements OnInit {
  public role = { roles: ["CRM"] };
  public zmUsers = new Array();
  public reassignForm: UntypedFormGroup;
  public reassignData = new Object();
  public zmList = [];
  constructor(public dialogRef: MatDialogRef<AssignleadComponent>, public modalService: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: any, public fb: UntypedFormBuilder, public snackBar: MatSnackBar
  ) {
    this.reassignForm = this.fb.group({
      userid: ['', [Validators.required]]
    })
  }

  ngOnInit(): void {
    this.reassignData['leads'] = Object.keys(this.data.reAssigned);
    this.reassignData['role'] = 'CRM';
    this.getZmData();
  }
  getZmData() {
    this.modalService.getZm(`users/by/roles`, this.role).subscribe((response) => {
      response.payload.users.map(ele => {
        this.zmUsers.push(ele);
        let data = { userid: ele.userid };
        this.zmList = [...this.zmList, data]
      })
    },
      (err) => {
      });
  }
  public customSearchFn(word: string, item): boolean {
    return item.userid.toLocaleLowerCase() == word.toLocaleLowerCase();
  }
  // customSearchFn(term: string, item) {
  //   item.userid = item.userid.replace(',', '');
  //   term = term.toLocaleLowerCase();
  //   return item.userid.toLocaleLowerCase().indexOf(term) > -1 || item.userid.toLocaleLowerCase() == term;
  // }
  onUserSelect(user) {
    if (user) {
      let selectedUserpPincode = this.zmUsers.filter(ele => ele.userid == user.userid ? ele.pincodes : '');
      this.reassignData['pincodes'] = selectedUserpPincode[0].pincodes;
      this.reassignData['userid'] = user.userid;
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  ReassignLead() {
    this.modalService.reAssignLead(`lead/reassign`, this.reassignData).subscribe((response) => {
      this.snackBar.open('lead Reassigned sucessfully', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      this.dialogRef.close('reassigned');
    },
      (err) => {
        this.snackBar.open(err.error?.message, 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      });
  }

}
